{
  "back_home": "Back to Home",
  "error_403_subtitle": "Sorry, you are not authorized to access this page.",
  "error_404_subtitle": "Sorry, the page you visited does not exist.",
  "error_boundary_title": "Page failed to load",
  "error_boundary_subtitle": "Please refresh the page and try again",
  "user_center": "User Center",
  "logout": "Logout",
  "logout_confirm": "Are you sure you want to logout?",
  "please_login": "Please Login",
  "menu_search_title": "Search menus",
  "menu_search_placeholder": "Enter a menu name",
  "menu_search_empty": "No matching menus found",
  "menu_search_shortcut_hint": "Search menus ({{shortcut}})",
  "advanced_filter": "Advanced Filter",
  "filter_count": "{{count}} items",
  "btn_add": "Add",
  "btn_delete": "Delete",
  "btn_delete_confirm_title": "Are you sure to delete?",
  "btn_delete_confirm_content": "This action will delete the data and cannot be undone.",
  "btn_import": "Import",
  "btn_export": "Export",
  "btn_search": "Search",
  "btn_reset": "Reset",
  "btn_save": "Save",
  "btn_cancel": "Cancel",
  "btn_copy": "Copy",
  "btn_paste": "Paste"
}
